/*
  Task 7399 / BR-056 and amend 2 (Najam 17 Oct 2026): checkout is closed while the cart holds
    - a 1-month (1 MOS) term, or
    - a band below the minimum, or a quantity below the minimum:
        10 on "License Subscription Bands" and on the four Sophos "Select Band" products with a 1-9 band
           (EDR - User, EDR - Server, Email Monitoring System, Identity Threat Detection and Response) (whole-band lines
           such as "1-499 users" pass),
        10 users on Avast Business per-user products ("License Users Bands"),
        10 users on a Barracuda "1 User" / "Per User" choice (the 1-month choice itself stays),
        100 assets on SolarWinds asset-management packs, 10 GB on SolarWinds Observability log storage, or
    - a product the store does not show (AVG TuneUp).
  The same rule is in snippets/softech-min10-rule.liquid (+ softech-min10-need, softech-min10-gone):
  line messages and first paint. This file keeps the checkout buttons closed after cart changes without a
  page load, stops the "added to cart" pop-up's Check out, tells Buy now (softech-product-cta.js) where to
  go, and keeps a product page's quantity field at the variant's minimum after a variant change.
  The Shopify Basic plan has no checkout validation for custom code, so a visitor who types a
  cart link by hand is not stopped here - see the task 7399 register.
*/
(function (root) {
  'use strict';

  function str(s) { return String(s == null ? '' : s).trim(); }
  function low(s) { return str(s).toLowerCase(); }

  // BR-056 amend 2: products the store does not show at all.
  function gone(vendor, title) {
    return low(vendor) === 'avg - home' && low(title).indexOf('tuneup') !== -1;
  }

  // The four Sophos "Select Band" products that sell a 1-9 band (Endpoint for Legacy Platforms is not touched).
  var SOPHOS4 = ['sophos edr - user', 'sophos edr - server', 'sophos email monitoring system', 'sophos identity threat detection and response'];

  // Which minimum one option value carries: {min, mode, unit, lo, hi} or null. Same as softech-min10-rule.liquid.
  function policy(vendor, title, name, value) {
    var n = low(name), vend = low(vendor), t = low(title), v = str(value), vl = v.toLowerCase();
    var min = 0, mode = '', unit = '';
    if (n === 'license subscription bands') { min = 10; mode = 'whole'; }
    else if (n === 'select band' && vend === 'sophos' && SOPHOS4.indexOf(t) !== -1) { min = 10; mode = 'whole'; }
    else if (n === 'license users bands' && vend === 'avast business') { min = 10; mode = 'unit'; unit = 'users'; }
    else if (n === 'select band' && vend === 'solarwinds' && t.indexOf('asset management') !== -1) { min = 100; mode = 'unit'; unit = 'assets'; }
    else if (n === 'select band' && vend === 'solarwinds' && t.indexOf('observability saas logs') !== -1) { min = 10; mode = 'unit'; unit = 'GB'; }
    else if (vend === 'barracuda networks') {
      var pv = ', ' + vl + ',';
      if (pv.indexOf(', 1 user,') !== -1 || pv.indexOf('per user') !== -1) { min = 10; mode = 'item'; unit = 'users'; }
    }
    if (!mode) return null;
    var lo = 0, hi = 0;
    if (mode === 'whole' || mode === 'unit') {
      var tok = v.split(' ')[0];
      if (!/^\d/.test(tok)) return null;
      if (!unit) { var words = v.replace(tok, '').trim(); if (words) unit = words; }
      var nums = tok.replace(/[+,]/g, '').split('-');
      lo = parseInt(nums[0], 10) || 0;
      hi = parseInt(nums[nums.length - 1], 10) || 0;
      if (tok.indexOf('+') !== -1) hi = Infinity;
    }
    return { min: min, mode: mode, unit: unit || 'users', lo: lo, hi: hi };
  }

  // A value the storefront hides (1 MOS term, a band below the minimum).
  function hidden(vendor, title, name, value) {
    if (str(value).toUpperCase() === '1 MOS') return true;
    var p = policy(vendor, title, name, value);
    return !!(p && p.mode !== 'item' && p.hi > 0 && p.hi < p.min);
  }

  // What one variant needs: {why: ''|'mos'|'band'|'gone', min, unit}. Same as softech-min10-need.liquid.
  function need(vendor, title, names, values) {
    var out = { why: gone(vendor, title) ? 'gone' : '', min: 0, unit: 'users' };
    for (var i = 0; i < values.length; i++) {
      if (str(values[i]).toUpperCase() === '1 MOS') { out.why = 'mos'; break; }
      var p = policy(vendor, title, names[i], values[i]);
      if (!p) continue;
      if (p.mode !== 'item' && p.hi > 0 && p.hi < p.min) { out.why = 'band'; out.min = p.min; out.unit = p.unit; break; }
      if ((p.mode !== 'whole' || p.lo >= p.min) && p.min > out.min) { out.min = p.min; out.unit = p.unit; }
    }
    return out;
  }

  // '' when the cart line may go to checkout, else the reason ('mos' | 'band' | 'gone' | 'qty').
  function lineBlocked(item) {
    var opts = item.options_with_values || [];
    var r = need(item.vendor, item.product_title,
      opts.map(function (o) { return o.name; }), opts.map(function (o) { return o.value; }));
    if (r.why) return r.why;
    if (r.min > 0 && item.quantity < r.min) return 'qty';
    return '';
  }

  function cartBlocked(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) if (lineBlocked(items[i])) return true;
    return false;
  }

  var api = { gone: gone, policy: policy, hidden: hidden, need: need, lineBlocked: lineBlocked, cartBlocked: cartBlocked };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.SoftechMin10 = api;
  if (typeof document === 'undefined') return;

  var me = document.currentScript;
  var startCount = me && me.getAttribute('data-cart-count');
  var blocked = null;
  var MSG = 'Checkout is closed: a line in your cart is below its minimum quantity, on a 1-month term, or not sold online. See the note on that line.';

  function apply() {
    Array.prototype.forEach.call(document.querySelectorAll('.cart__dynamic-checkout-buttons'), function (d) {
      d.hidden = !!blocked;
    });
    var ids = ['checkout', 'CartDrawer-Checkout'];
    ids.forEach(function (id) {
      var b = document.getElementById(id);
      if (!b) return;
      if (blocked) {
        b.setAttribute('disabled', 'disabled');
        b.setAttribute('data-sm10-closed', '1');
      } else if (b.getAttribute('data-sm10-closed')) {
        b.removeAttribute('disabled');
        b.removeAttribute('data-sm10-closed');
      }
      var wrap = b.parentNode, note = wrap && wrap.querySelector('.sm10-checkout-note');
      if (blocked && wrap && !note) {
        note = document.createElement('p');
        note.className = 'sm10-checkout-note';
        note.setAttribute('role', 'alert');
        note.textContent = MSG;
        wrap.insertBefore(note, b);
      } else if (!blocked && note) {
        note.parentNode.removeChild(note);
      }
    });
  }

  function cartUrl(path) {
    var base = (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/';
    return base + path;
  }

  function refresh() {
    return fetch(cartUrl('cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { blocked = cartBlocked(cart); apply(); return blocked; })
      .catch(function () { return blocked; });
  }
  api.refresh = refresh;

  // Any "Check out" submit (cart page, drawer, added-to-cart pop-up) while the cart is blocked goes to the cart page.
  document.addEventListener('submit', function (e) {
    var sub = e.submitter;
    var isCheckout = (sub && sub.name === 'checkout') || (e.target && e.target.id === 'cart-notification-form');
    if (!isCheckout || !blocked) return;
    e.preventDefault();
    root.location.href = cartUrl('cart');
  }, true);

  // Product page: after a variant change the theme copies the new variant's data-min (sections/main-product.liquid,
  // softech-min10-need) but keeps the old field limits. A product with a band box (softech-user-bands.js,
  // class sb-on) manages its own field and is left alone.
  function fixQtyMin() {
    Array.prototype.forEach.call(document.querySelectorAll('.product-form__quantity .quantity__input'), function (el) {
      if (el.closest('.sb-on')) return;
      var m = parseInt(el.getAttribute('data-min'), 10);
      if (isNaN(m) || m < 1) return;
      el.min = m;
      var v = parseInt(el.value, 10);
      if (isNaN(v) || v < m) el.value = m;
      var qi = el.closest('quantity-input');
      if (qi && qi.validateQtyRules) qi.validateQtyRules();
    });
  }
  api.fixQtyMin = fixQtyMin;

  function start() {
    if (startCount !== '0') refresh(); // an empty cart needs no check until something is added
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 0); });
      if (PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(fixQtyMin, 0); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})(typeof window !== 'undefined' ? window : this);
